import React from 'react';
import { Sparkles } from 'lucide-react';
import './IdentitySection.css';

interface FeatureCardProps {
  name: string;
  description: string;
  icon?: React.ReactNode;
  variant?: 'default' | 'heritage' | 'community';
}

/**
 * FeatureCard - Display component for traits, features, and abilities
 * Used for heritage traits and community features
 */
const FeatureCard: React.FC<FeatureCardProps> = ({
  name,
  description,
  icon,
  variant = 'default'
}) => {
  return (
    <div className={`feature-card feature-card--${variant}`}>
      <div className="feature-card__header">
        <div className="feature-card__icon">
          {icon || <Sparkles size={16} />}
        </div>
        <h4 className="feature-card__name">{name}</h4>
      </div>
      <div className="feature-card__description">
        {description}
      </div>
    </div>
  );
};

export default FeatureCard;
